export default "__VITE_ASSET__9a5c9105__"